import { SensitiveGoodsGroupComponent } from './SensitiveGoodsGroupComponent';
import { StakeholderGroupComponent } from './StakeholderGroupComponent';
export const GROUP_OVERRIDES = {
    InStoreStakeholder: StakeholderGroupComponent,
    SensitiveGoods: SensitiveGoodsGroupComponent,
};
